<template>
	<div>
		<div class="inner-content left">
			<h1>{{$t('generic.page_not_found')}}</h1>
			<div>
				<router-link to="/">Home</router-link>
			</div>
		</div>
  </div>
</template>

<script>
export default {
    name : "PageNotFound"
};
</script>
